import {matchPath, useLocation} from 'react-router-dom'

import {AnalyticsRoutesEnum} from 'interfaces'

export const useIsAIUsageUsersView = (): boolean => {
  const {pathname} = useLocation()

  return Boolean(
    matchPath(pathname, {
      path: AnalyticsRoutesEnum.ANALYTICS_AI_USAGE_USERS,
      exact: true,
    }),
  )
}
